

export const Wait_Pay_TXT = []
Wait_Pay_TXT["en"] = "Waiting For Payment"
Wait_Pay_TXT["th"] = "รอการชำระเงิน"


export const Room_TXT = []
Room_TXT["en"] = "Room"
Room_TXT["th"] = "ห้อง"

export const General_Expense_TXT = []
General_Expense_TXT["en"] = "General Expenses"
General_Expense_TXT["th"] = "ค่าใช้จ่ายทั่วไป"

export const Pay_Within_TXT = []
Pay_Within_TXT["en"] = "Pay Within"
Pay_Within_TXT["th"] = "ชำระเงินภายใน"

export const Baht_TXT = []
Baht_TXT["en"] = "Baht"
Baht_TXT["th"] = "บาท"

export const Installment_TXT = []
Installment_TXT["en"] = "Installment"
Installment_TXT["th"] = "งวด"

export const Pending_Pay_TXT = []
Pending_Pay_TXT["en"] = "Pending Payment"
Pending_Pay_TXT["th"] = "ค่างวดรอชำระ"

export const Pending_Rent_TXT = []
Pending_Rent_TXT["en"] = "Outstanding"
Pending_Rent_TXT["th"] = "ค่าเช่าค้างชำระ"

export const Choose_Method_TXT = []
Choose_Method_TXT["en"] = "Choose a payment method"
Choose_Method_TXT["th"] = "เลือกวิธีการชำระเงิน"

export const Choose_Method_Block_Title_TXT = []
Choose_Method_Block_Title_TXT["en"] = "Sorry for the inconvenience."
Choose_Method_Block_Title_TXT["th"] = "ขออภัยในความไม่สะดวก"

export const Choose_Method_Block_Title_2_TXT = []
Choose_Method_Block_Title_2_TXT["en"] = "The payment system is currently undergoing maintenance."
Choose_Method_Block_Title_2_TXT["th"] = "ขณะนี้อยู่ระหว่างปิดปรับปรุงระบบการชำระเงิน"

export const Choose_Method_Block_Title_3_TXT = []
Choose_Method_Block_Title_3_TXT["en"] = "If you encounter any issues, please contact our"
Choose_Method_Block_Title_3_TXT["th"] = "หากพบปัญหารบกวนติดต่อเจ้าหน้าที่"


export const Pay_via_Qr_TXT = []
Pay_via_Qr_TXT["en"] = "Pay via QR Code"
Pay_via_Qr_TXT["th"] = "ชำระผ่าน QR Code"

export const Pay_via_Card_TXT = []
Pay_via_Card_TXT["en"] = "Pay via Credit Card"
Pay_via_Card_TXT["th"] = "ชำระผ่าน Credit Card"

export const Pay_via_MobileBank_TXT = []
Pay_via_MobileBank_TXT["en"] = "Pay via Mobile Banking"
Pay_via_MobileBank_TXT["th"] = "ชำระผ่าน Mobile Banking"

export const Pay_via_2c2p_TXT = []
Pay_via_2c2p_TXT["en"] = "Pay via 2C2P"
Pay_via_2c2p_TXT["th"] = "ชำระผ่าน 2C2P"


export const Pay_Due_TXT = []
Pay_Due_TXT["en"] = "Payment Due"
Pay_Due_TXT["th"] = "กำหนดชำระ"

export const Pay_Date_TXT = []
Pay_Date_TXT["en"] = "Payment Date"
Pay_Date_TXT["th"] = "วันที่ชำระ"

export const Bill_Type_TXT = []
Bill_Type_TXT["en"] = "Type"
Bill_Type_TXT["th"] = "ประเภท"

export const Pay_Via_TXT = []
Pay_Via_TXT["en"] = "Pay Via"
Pay_Via_TXT["th"] = "ชำระโดย"

export const Bill_Amount_TXT = []
Bill_Amount_TXT["en"] = "Amount"
Bill_Amount_TXT["th"] = "จำนวนเงิน"

export const Bill_Status_TXT = []
Bill_Status_TXT["en"] = "Status"
Bill_Status_TXT["th"] = "สถานะ"

export const Split_Payment_TXT = []
Split_Payment_TXT["en"] = "You can split the payment for the contract"
Split_Payment_TXT["th"] = "ท่านสามารถแบ่งชำระเงินทำสัญญา"

export const Split_Payment_2_TXT = []
Split_Payment_2_TXT["en"] = "into "
Split_Payment_2_TXT["th"] = "ออกเป็น"

export const Split_Payment_3_TXT = []
Split_Payment_3_TXT["en"] = "installments"
Split_Payment_3_TXT["th"] = "งวด"

export const Split_Payment_4_TXT = []
Split_Payment_4_TXT["en"] = "installments of "
Split_Payment_4_TXT["th"] = "จำนวนเงิน งวดละ"

export const Split_Payment_5_TXT = []
Split_Payment_5_TXT["en"] = "baht each."
Split_Payment_5_TXT["th"] = "บาท"

export const Over_Payment_Due_TXT = []
Over_Payment_Due_TXT["en"] = "Overdue"
Over_Payment_Due_TXT["th"] = "เกินกำหนดชำระ"

export const Wait_Payment_TXT = []
Wait_Payment_TXT["en"] = "Pending"
Wait_Payment_TXT["th"] = "รอดำเนินการ"

export const Receipt_Payment_TXT = []
Receipt_Payment_TXT["en"] = "Receipt"
Receipt_Payment_TXT["th"] = "ใบเสร็จรับเงิน"

export const Payment_Not_Available_TXT = []
Payment_Not_Available_TXT["en"] = "This Payment cannot Pay-In from Line OA"
Payment_Not_Available_TXT["th"] = "ไม่สามารถชำระเงินผ่าน line OA"

export const Invoice_No_TXT = []
Invoice_No_TXT["en"] = "No."
Invoice_No_TXT["th"] = "เลขที่"

export const Invoice_Doc_TXT = []
Invoice_Doc_TXT["en"] = "Invoice"
Invoice_Doc_TXT["th"] = "ใบแจ้งหนี้"

export const Pay_TXT = []
Pay_TXT["en"] = "Pay"
Pay_TXT["th"] = "ชำระ"

export const Total_Amount_TXT = []
Total_Amount_TXT["en"] = "Total Amount"
Total_Amount_TXT["th"] = "ยอดชำระทั้งหมด"

export const Total_overdude_balance_TXT = []
Total_overdude_balance_TXT["en"] = "Overdue Balance"
Total_overdude_balance_TXT["th"] = "ยอดที่ต้องชำระ"

export const Total_all_balance_TXT = []
Total_all_balance_TXT["en"] = "Outstanding Balance "
Total_all_balance_TXT["th"] = "ยอดคงเหลือ"

export const main_overdude_TXT = []
main_overdude_TXT["en"] = "Master Contract"
main_overdude_TXT["th"] = "สัญญาหลัก"

export const extend_overdude_TXT = []
extend_overdude_TXT["en"] = "Extend Contract"
extend_overdude_TXT["th"] = "สัญญาต่อ"

export const Summary_overdude_balance_TXT = []
Summary_overdude_balance_TXT["en"] = "Total Overdue Balance"
Summary_overdude_balance_TXT["th"] = "รวมยอดที่ต้องชำระ"

export const Summary_Total_all_balance_TXT = []
Summary_Total_all_balance_TXT["en"] = "Total Outstanding Balance"
Summary_Total_all_balance_TXT["th"] = "รวมยอดคงเหลือ"

export const No_Data_TXT = []
No_Data_TXT["en"] = "No Data"
No_Data_TXT["th"] = "ไม่มีข้อมูล"

export const Upload_Slip_TXT = []
Upload_Slip_TXT["en"] = "Upload Slip"
Upload_Slip_TXT["th"] = "อัปโหลดสลิป"

export const Upload_Slip_Error_TXT = []
Upload_Slip_Error_TXT["en"] = "Failed to upload slip"
Upload_Slip_Error_TXT["th"] = "ไม่สามารถอัปโหลดสลิปได้"